
import { defineComponent } from "vue";
import api, { ReceiverExportList, ReceiverExport, RequestPaging, PageBounding, RequestSort }  from "../../api/backend-api";
import { getSkipParamForPage, getPageBounding } from "../../util/paginationHelpers";
import { AxiosError } from "axios";
import { getHumanDate } from "../../util/luxonDateHelpers";

interface ReceiverExportRequestFilter extends ReceiverExport {
    export_status?: string
}

interface State {
  msg: string;
  backendResponse: ReceiverExportList;
  requestFilter: ReceiverExportRequestFilter;
  requestPaging: RequestPaging;
  requestSorting: RequestSort;
  pageBounds: PageBounding[];
  errors: AxiosError[];
}

export default defineComponent({
  name: "ReceiverExport",
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },

  data: (): State => {
    const receiverexport_list = { } as ReceiverExportList;
    const receiverexport_struct = { } as ReceiverExportRequestFilter;
    const paging_struct = { Limit: 20, Skip: 0, Options: [ 20, 50, 100 ] } as RequestPaging;
    const sort_struct = { Pattern: '-id' } as RequestSort;

  return {
      msg: "Receiver Export",
      backendResponse: receiverexport_list,
      requestFilter: receiverexport_struct,
      requestPaging: paging_struct,
      requestSorting: sort_struct,
      pageBounds: [],
      errors: [],
    };
  },
  methods: {
    // Fetches posts when the component is created.
    getHumanDate,
    getSkipParamForPage,
    getPageBounding,
    setPage(command: string|number) {
      this.requestPaging.Skip = getSkipParamForPage(command, this.requestPaging.Skip, this.requestPaging.Limit);
      this.getList();
    },
    clearFiltersAndRefresh() {
      const filter_struct = { } as ReceiverExportRequestFilter;
      this.requestFilter = filter_struct;
      this.getList()
    },
    processRequestFilter(filter: ReceiverExportRequestFilter): ReceiverExport {
        let _filter = {} as ReceiverExport
        let _proto: {[key: string]: any} = {}
        for (const [_k, _v] of Object.entries(filter)) {
            if (_v == "") continue
            if (_k == 'export_status') {
                if (_v == 'pending') _proto['Processed'] = null
                if (_v == 'processed') {
                    _proto['Processed'] = {Neq: null}
                    _proto['Exported'] = null
                }
                if (_v == 'exported') _proto['Exported'] = {Neq: null}
                continue
            }
            _proto[_k] = _v
        }
        if (Object.keys(_proto).length) {
            Object.assign(_filter, _proto)
        }
        
        return _filter
    },
    getList() {
      this.backendResponse = { } as ReceiverExportList;
      const request_params = api.createRequestParams(this.processRequestFilter(this.requestFilter), this.requestPaging, this.requestSorting)
      api
        .getReceiverExportList(request_params)
        .then((response) => {
          this.backendResponse = response.data;
          this.pageBounds = this.getPageBounding(this.backendResponse.count, this.requestPaging.Limit, this.requestPaging.Skip)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });
    },
  },
});
